import React from "react";
import { Link } from "react-router-dom";

import UsersByCountry from "../UsersByCountry";

import Forum from "../../Forum";
import Chat from "../../Chat";

import { VIEWER_ZONE_DOMAIN } from "../../../config/defaults";
import IframePlayer from "./iframePlayer";
import Loading from "../../../components/Loading";

import "../../../css/EventResume.css";

import FirstRow from "./FirstRow";
import Cities from "./Cities";
import ViewersByHour from "./ViewersByHour";

const View = ({
  loading,
  hasData,
  isError,
  total_viewers,
  viewers_peak,
  limitCountries,
  countriesLength,
  countries,
  hours,
  iframeHeight,
  cities,
  limitCities,
  event,
  eventStatus,
  user,
  playerContainer,
  firebase,
  onViewMoreCountries,
  onViewMoreCities,
  onResize,
}) => {
  if (eventStatus.code === 0) {
    return (
      <div className="row row-sm row-xl cnt-no-setup-event">
        <i className="fas fa-tools"></i>
        <h4>
          Primero debes <Link to="./edit">configurar</Link> tu evento. Si tienes
          dudas ve <Link to="./help">aquí</Link>
        </h4>
      </div>
    );
  }
  if (loading) {
    return <Loading isFullScren />;
  }

  return (
    <React.Fragment>
      {!hasData && (
        <div className="row row-sm row-xl">
          <div className="col-sm-8 row-eq-height">
            <div className="card card-dashboard-twentyone">
              <div className="row no-gutters">
                <div className="card-body">
                  <h1>Aún no hay información para mostrar de éste evento</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {hasData && (
        <div className="row row-sm row-xl">
          <div className="col-sm-8 col-xl-8 row-eq-height">
            <FirstRow
              isLoading={countries === false}
              isError={isError}
              live_viewers={event.current_viewers}
              total_viewers={total_viewers}
              average_time={event.avg_time}
              viewers_peak={viewers_peak || 0}
            />
            {countries !== false && (
              <div className="row row-sm row-xl mg-t-20">
                <div className="col-sm-6 col-xl-6 mg-t-20 mg-xl-t-0">
                  <ViewersByHour hours={hours} type={"HOURS"} />
                </div>
                <div className="col-sm-6 col-xl-6 mg-t-20 mg-xl-t-0">
                  <div className="card card-dashboard-twentyone">
                    <div className="row no-gutters">
                      <div className="card-body p-relative">
                        <h6 className="az-content-label">
                          Espectadores por país
                        </h6>
                        <p>
                          Estos son{" "}
                          {limitCountries && countriesLength > 4
                            ? "los principales"
                            : "todos los"}{" "}
                          países desde donde se ha sintonizado tu transmisión.
                        </p>

                        <UsersByCountry
                          countries={countries}
                          limitCountries={limitCountries}
                        />
                        {countriesLength > 4 && (
                          <button
                            className="view-more"
                            onClick={onViewMoreCountries}
                          >
                            Ver{" "}
                            {limitCountries
                              ? `todos (${countries.length})`
                              : "menos"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-sm-4 col-xl-4 row-eq-height video-1">
            <div className="card card-body card-dashboard-twentyone ht-xl-100p">
              <h6 className="card-title tx-14 mg-b-10">
                Previsualización del Evento
              </h6>
              <div className="media" style={{ flexWrap: "wrap" }}>
                <div className="player-contenedor">
                  <div
                    className="player-sombra"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <IframePlayer
                      onResize={onResize}
                      iframeHeight={iframeHeight}
                      playerContainer={playerContainer}
                      eventId={event.id}
                      streamId={event.live_stream.id}
                      startTime={event._startDate}
                      sttk={event.sttk}
                      src={
                        event.live_stream
                          ? event.live_stream.player_hls_playback_url
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div>
                <h6>Puedes ver la transmisión completa en: </h6>
                <a
                  href={`${VIEWER_ZONE_DOMAIN}/${event.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {VIEWER_ZONE_DOMAIN}/{event.url}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row row-sm row-xl mg-t-20 app-view-zone light-theme">
        {hasData && cities !== false && (
          <div className="col-sm-4 row-eq-height">
            <Cities
              cities={cities}
              limitCities={limitCities}
              onMoreClick={onViewMoreCities}
              total_viewers={total_viewers}
            />
          </div>
        )}
        {event.chat === "true" && (
          <div className="col-sm-4 row-eq-height">
            <div className="card card-dashboard-twentyone">
              <div className="row no-gutters">
                <div className="card-body">
                  <h6 className="az-content-label">Chat</h6>
                  <div className="chat-completo">
                    <Chat
                      firebase={firebase}
                      author={user}
                      event_id={event.id}
                      owner={event.owner}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {event.qANDa === "true" && (
          <div className="col-sm-4 row-eq-height">
            <div className="card card-dashboard-twentyone">
              <div className="row no-gutters">
                <div className="card-body">
                  <h6 className="az-content-label">Preguntas y repuestas</h6>
                  <div className="preguntas">
                    <Forum
                      firebase={firebase}
                      author={user}
                      event_id={event.id}
                      owner={event.owner}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default View;
